"use client";

import { useCallback } from "react";
import type { CourseAnalyticsProperties, TrackCourseEvent } from "@artha/types";
import { useAnalytics } from "@/lib/analytics/useAnalytics";
import { useAudienceAnalyticsContext } from "@/lib/analytics/AudienceAnalyticsContext";
import { courseAnalyticsProperties } from "./courseAnalytics";
import { COURSE_ANALYTICS } from "./course-analytics.constants";

/** Audience adapter: reuse existing providers/identity; creator is attribution only. */
export function useCourseAnalytics(
  context: CourseAnalyticsProperties = {},
  creatorHandle?: string,
): TrackCourseEvent {
  const { trackEvent } = useAnalytics();
  const { username, creatorId } = useAudienceAnalyticsContext();
  const handle = (creatorHandle ?? username)?.replace(/^@/, "");
  return useCallback(
    (event, properties) => {
      try {
        trackEvent(event, {
          ...courseAnalyticsProperties(context),
          ...courseAnalyticsProperties(properties ?? {}),
          entity_type: COURSE_ANALYTICS.entityType,
          ...(handle && { username: handle }),
          ...(creatorId && { portal_id: creatorId }),
        });
      } catch {
        // Analytics must never block OTP, submission or navigation.
      }
    },
    [trackEvent, context, handle, creatorId],
  );
}
